import { Injectable } from '@angular/core';
import { Mutation } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root',
})
export class UpdatePermission extends Mutation {
  document = gql(`
    mutation updatePermission($uid: ID!, $input: ModelPermissionInput) {
      updatePermission(uid: $uid, input: $input) {
        code
      }
    }
  `);
}

@Injectable({
  providedIn: 'root',
})
export class InsertPermission extends Mutation {
  document = gql(`
    mutation insertPermission($accountUid: ID!, $input: ModelPermissionInput) {
      insertPermission(accountUid: $accountUid, input: $input) {
        code
      }
    }
  `);
}

@Injectable({
  providedIn: 'root',
})
export class DeletePermission extends Mutation {
  document = gql(`
    mutation deletePermission($uid: ID!) {
      deletePermission(uid: $uid) {
        code
      }
    }
  `);
}

@Injectable({
  providedIn: 'root',
})
export class UpdateUserPermissions extends Mutation {
  document = gql(`
    mutation updateUserPermissions($input: [ModelUserPermissionInput]) {
      updateUserPermissions(input: $input) {
        code
      }
    }
  `);
}

@Injectable({
  providedIn: 'root',
})
export class InsertUserPermissions extends Mutation {
  document = gql(`
    mutation insertUserPermissions($input: [ModelUserPermissionInput]) {
      insertUserPermissions(input: $input) {
        code
      }
    }
  `);
}

@Injectable({
  providedIn: 'root',
})
export class DeleteUserPermissions extends Mutation {
  document = gql(`
    mutation deleteUserPermissions($input: [ModelUserPermissionDeleteInput]) {
      deleteUserPermissions(input: $input) {
        code
      }
    }
  `);
}
